module.exports = __webpack_public_path__ + "img/tab-blue.f58161a8.svg";